import { inject, injectable } from 'inversify'
import { get } from 'lodash-es'
import type { PaginationUrlFilterScalarValueType } from '@/services/tables/types'
import {
  type FilterToFormattedTextConvertable,
  type FormattedTextNode,
  type TmCountryCode,
  FilterOperationEnum,
  type FormattedTextBadgesValueItem,
} from '@/services/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type CountryService from '@/services/domain/countryService'
import type TranslateService from '@/services/translateService'

@injectable()
export default class CountryFilterMapper implements FilterToFormattedTextConvertable {
  constructor(
    @inject(SERVICE_TYPES.CountryService) protected readonly countryService: CountryService,
    @inject(SERVICE_TYPES.TranslateService) protected readonly translateService: TranslateService,
  ) {}

  public toFormattedText(filterValue: PaginationUrlFilterScalarValueType): FormattedTextNode[] {
    const countryCodes = get(filterValue, [FilterOperationEnum.in], []) as Array<TmCountryCode | '0'>
    const hasEmptyCode = countryCodes.includes('0')

    const result: FormattedTextNode[] = []
    if (hasEmptyCode) {
      result.push({
        type: 'italic',
        value: this.translateService.t('myContactsFilters.isEmpty'),
      })
    }
    const badges: FormattedTextBadgesValueItem[] = countryCodes
      .filter((code) => code !== '0')
      .map((code) => {
        return {
          name: this.countryService.getCountryName(code),
        }
      })
    if (badges.length > 0) {
      result.push({
        type: 'badges',
        value: badges,
      })
    }
    return result
  }
}
